import { Text, Toggle } from '@bitrise/bitkit';
import { TypeCrashStatus } from '@trace/types';
import React, {
  ChangeEventHandler,
  FunctionComponent,
  useCallback,
  useContext,
  useState,
} from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router';

import { ApiContext } from '../../Api/Api';

export interface Props {
  defaultStatus: TypeCrashStatus;
}

const CrashStatusToggle: FunctionComponent<Props> = ({ defaultStatus }) => {
  const { crashId } = useParams<{ crashId: string }>();
  const { put } = useContext(ApiContext);
  const queryClient = useQueryClient();
  const { mutate } = useMutation((newStatus: TypeCrashStatus) =>
    put(`/issues/${crashId}/${newStatus}`),
  );
  const [isChecked, setIsChecked] = useState(defaultStatus === 'open');

  const handleToggleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(() => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
    mutate(newCheckedState ? 'open' : 'closed', {
      onError: () => {
        setIsChecked(!newCheckedState);
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['crash', crashId]);
      },
    });
  }, [crashId, isChecked, queryClient, mutate]);

  return (
    <Toggle textColor="gray-7" checked={isChecked} onChange={handleToggleChange}>
      <Text weight="bold">{isChecked ? 'Open' : 'Closed'}</Text>
    </Toggle>
  );
};

export default CrashStatusToggle;
